// Copyright (c) Zammo Inc.

import React from 'react';
import Modal from 'react-modal';
import styled from 'styled-components';

const Container = styled.div`
  font-size: 1rem;

  > div {
    margin-bottom: 1rem;
    line-height: 1.5;
  }
`;

const style = {
  content: {
    bottom: 'auto',
    height: 'auto', // set height
    left: '50%',
    padding: '2rem',
    right: 'auto',
    top: '50%', // start from center
    transform: 'translate(-50%, -50%)', // adjust top "up" based on height
    width: 'calc(100% - 2rem)',
    maxWidth: '500px',
  },
};

interface Props {
  isOpen: boolean;
}
function SessionFailedModal({ isOpen }: Props) {
  return (
    <Modal isOpen={isOpen} style={style}>
      <Container>
        <div>
          It looks like the token you are trying to use is expired. Please refresh your token to re-share with your team
          or contact your administrator.
        </div>
      </Container>
    </Modal>
  );
}

export default SessionFailedModal;
